import React from "react";
import PropTypes from "prop-types";
import className from "classnames";
import ReactTable from "react-table";
import { getColumnWidth } from "./utils";
import "react-table/react-table.css";
import "./table.style.scss";

class Table extends React.Component {
  get expanded() {
    return this.props.expandAll
      ? this.props.data.reduce((acc, value, index) => {
          acc[index] = true;
          return acc;
        }, {})
      : this.props.expanded;
  }

  extendColumn(rows, column) {
    return Object.assign({}, column, {
      className: className("fc-td", column.className),
      headerClassName: "fc-th bg-light-grey border-bottom border-grey border-right-0 text-left",
      width: getColumnWidth(rows, column),
    });
  }

  render() {
    return (
      <div style={{ overflow: "auto" }}>
        {!this.props.data || this.props.data.length < 1 ? (
          <h3 className="text-center text-secondary">No results for the specified criteria</h3>
        ) : (
          <ReactTable
            {...this.props}
            style={{ width: this.props.width }}
            manual
            className={className("fc-table border-top ", this.props.className)}
            minRows={0}
            resizable={false}
            showPagination={false}
            expanded={this.expanded}
            columns={this.props.columns.map(column => this.extendColumn(this.props.data, column))}
            NoDataComponent={() => ""}
          />
        )}
      </div>
    );
  }
}

Table.propTypes = {
  width: PropTypes.string,
  expandAll: PropTypes.bool,
  headerColor: PropTypes.string,
  ...ReactTable.propTypes,
};

Table.defaultProps = {
  width: "auto",
  expandAll: false,
  headerColor: "light-grey",
};

export default Table;
